import React from 'react';
import { connect } from 'react-redux';
import { getCategories, saveCategory, editCategory, sortOrderCategory } from '../../store/actions';

const withCategories = WrappedComponent => {
  const mapStateToProps = state => ({
    productCategories: state.categories,
  });
  const mapDispatchToProps = dispatch => ({
    getCategories: () => dispatch(getCategories()),
    saveCategory: data => dispatch(saveCategory(data)),
    editCategory: (id, data) => dispatch(editCategory(id, data)),
    sortOrderCategory: data => dispatch(sortOrderCategory(data)),
  });
  const CategoriesContainer = props => {
    return <WrappedComponent {...props} />;
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(CategoriesContainer);
};

export default withCategories;



// WEBPACK FOOTER //
// ./src/containers/Categories/index.js